import { IAppointmentDetail } from "../models/AppointmentDetail"
import { apiHelper } from "./core"

const resourceServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL
const masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL

const getAppointmentByTypeOrStatus = (
  type: string,
  status: string,
  centerId: string
): Promise<Array<IAppointmentDetail>> => {
  let url = type ? `appointmentType=${type}&` : ""
  url = url + (status ? `status=${status}` : "")
  return apiHelper
    .get(
      `${resourceServiceBaseUrl}/appointments?${url}&centerId=${centerId}&sort=createdAt&order=DESC`
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAppointmentsByQuery = (
  query: any
): Promise<Array<IAppointmentDetail>> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/appointments?${query}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAppointmentsByPagination = (
  query: any
): Promise<Array<IAppointmentDetail>> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/appointments/pagination?${query}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const updateAppointment = (body: any): Promise<any> => {
  return apiHelper
    .put(`${resourceServiceBaseUrl}/appointments/${body?.id}`, body)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
const updateLeaveInfo = (query: any, body: any): Promise<any> => {
  return apiHelper
    .put(`${resourceServiceBaseUrl}/availability/unavailability?${query}`, body)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAppointmentById = (id: any): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/appointments/${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const fetchAppointmentCounts = (id: any): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/appointments/counts?centerId=${id}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const contactUs = (): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/centers/public`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//Book Appointments

//get Consultant Profile based on ConsultantId
const getConsultantProfile = (staffId: string): Promise<string> => {
  return apiHelper
    .get(`${userServiceBaseUrl}/staff/${staffId}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

//get Patient Information and Smart Summary
const getPatientInformation = (
  searchText?: string,
  centerId?: string
): Promise<string> => {
  let url = ""
  if (centerId) {
    url = `${userServiceBaseUrl}/patients?searchText=${searchText}&centerId=${centerId}`
  } else {
    url = `${userServiceBaseUrl}/patients?searchText=${searchText}`
  }
  return apiHelper
    .get(`${url}`)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getAvailabilitySlots = (
  data1: string,
  data2: string,
  data3: string
): Promise<any> => {
  var data = {
    consultantId: data1,
    centerId: data2,
    scheduleDate: data3,
  }

  return apiHelper
    .post(`${resourceServiceBaseUrl}/appointments/availableSlots`, data)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const bookAppointment = (appointment: any): Promise<any> => {
  return apiHelper
    .post(`${resourceServiceBaseUrl}/appointments`, appointment)
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const bookSpecialAppointment = (appointments: any): Promise<any> => {
  return apiHelper
    .post(`${resourceServiceBaseUrl}/appointments/special`, appointments)
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const getAvailability = (query: string): Promise<any> => {
  let url = query ? `availability${query}` : "availability"

  return apiHelper
    .get(`${resourceServiceBaseUrl}/${url}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const updateStaffLogout = (body: any): Promise<any> => {
  return apiHelper
    .put(`${userServiceBaseUrl}/staff/${body?.id}`, body)
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

const getLatestAppointmentDetails = (id: string): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/appointments/latest/${id}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const markAppointmentReadyForDischarge = (id: string): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/appointments/discharge-notification/${id}`)
    .then((res) => {
      return res
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

const updateSuggestedConsultationCharges = (
  id: string,
  body: any
): Promise<any> => {
  return apiHelper
    .put(
      `${resourceServiceBaseUrl}/appointments/${id}/suggested-consultation-charges`,
      body
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export {
  updateLeaveInfo,
  getAppointmentByTypeOrStatus,
  fetchAppointmentCounts,
  getPatientInformation,
  getConsultantProfile,
  getAvailabilitySlots,
  bookAppointment,
  updateAppointment,
  getAppointmentById,
  getAppointmentsByQuery,
  getAppointmentsByPagination,
  getAvailability,
  bookSpecialAppointment,
  contactUs,
  updateStaffLogout,
  getLatestAppointmentDetails,
  markAppointmentReadyForDischarge,
  updateSuggestedConsultationCharges,
}
